export default {
    login: {
        first: 'Creamos solución de sensor',
        second: 'para usted.',
        third: 'Nuestro diseño simple pero inteligente le proporcionará las herramientas para convertir los datos en tiempo real en un rendimiento comercial inmediatamente mejorado.',
        first_flower: 'we colour the public space with our durable plant concepts',
        second_flower: '',
        third_flower: 'We provide flowering public green spaces and large gardens throughout Europe. We do this by supplying and planting flower bulbs, wild flowers and perennials.',
        desc: 'Inicie sesión ingresando la información a continuación',
        username: 'Email',
        password: 'Contraseña',
        successful: 'Inicio de sesión correcto',
        logout: 'Cerrar sesión',
        login: 'Iniciar',
        in: 'sesión',
    },
    dashboard: {
        title: 'Tablero',
        search: 'Buscar',
        dealer_view: 'Dealer view',
        nav: {
            type: 'Tipo',
            batch: 'Calibración',
            location: 'Ubicación',
            remark: 'Observación',
            lqi: 'Enlace',
            lqi_hover: 'Indicador de calidad de enlace',
            unit: 'Tentacle',
            last_event: 'Último evento',
            l_update: 'Últimos datos',
            timing: 'Sincronización dinámica',
            sensing: 'Detección dinámica',
            notification: 'Alertas',
            customer: 'Cliente',
            favourite: 'Favorito',
        },
        bulk_setup: {
            substrate_properties: 'Propiedades del sustrato',
            frame_selection: 'Elección del marco de referencia',
            critical_value: 'Umbrales de notificación',
            payload_error: 'El formato de carga útil de los dispositivos seleccionados no es idéntico',
            hundred_tx_power: 'Calculado para una potencia de transmisión del 100%.',
            version_error: 'Levensduurberekening alleen beschikbaar voor apparaten met identieke uitvoeringen.',
            batch_type_error: 'El tipo de calibración del tentáculo no es idéntico (propiedades deshabilitadas)',
            batch_missing_error: 'La calibración de uno o más tentáculos no está configurada (propiedades deshabilitadas)',
            batch_all_error: 'Para continuar, configure todas las propiedades',
            affected: 'Cambio aplicado a {count} dispositivos',
            identical_version_error: 'Las versiones del dispositivo no son idénticas',
        },
        remark: {
            double_click: 'Doble clic',
            to_add: 'para agregar valor',
            history: 'Historial de comentarios',
            show_history: 'Mostrar historial de comentarios',
        },
    },
    map: {
        calculated: 'Ubicación calculada',
        manual: 'Colocación manual',
    },
    detail: {
        new_calib_point: 'Agregar nuevo punto de calibración',
        remove_calib_point: 'Quitar el punto de calibración',
        raw_value: 'Valor bruto',
        calibrate_min: 'Calibrar min.',
        calibrate_max: 'Calibrar máx.',
        apply_calib: 'Aplicar calibración a las propiedades',
        reset_minmax: 'Restablecer valores mínimos y máximos',
        reset_calib: 'Restablecer a la calibración asignada',
        select_props: 'Seleccione las propiedades para calibrar',
        save_props: 'Guardar en propiedades seleccionadas',
        percent: 'VWC',
        batch: 'Calibración',
        selected_batch: 'Calibración seleccionado',
        raw: 'Raw',
        warning: 'Advertencia',
        warning_vwc: 'El valor de VWC o el equivalente RAW no es válido. Corrija los valores para que sean superiores al mínimo, inferiores al máximo o cualquier otro valor que no exista.',
        measured_min: 'Mínimo medido',
        measured_max: 'Máximo medido',
        select_props: 'Seleccionar propiedades',
        lqi: 'La calidad del enlace',
        lqi_calculated: 'Calculado utilizando estaciones base.',
        map: 'Ubicación del sensor',
        sensor_setting: 'Ajustes del sensor',
        etentacles_setting: 'Configuración de iTentacles',
        min_value: 'Valor mínimo',
        last_value: 'Último valor',
        max_value: 'Valor máximo',
        select_data: 'Seleccionar datos',
        missing: 'Datos no disponibles',
        moisture_calibration: 'Calibración VWC',
        warning_batch_calibration: '¡Advertencia! ¡Está actualizando la calibración asignada!',
        warning_device_calibration2: '¡Advertencia! Para aplicar la calibración a las propiedades, haga clic en "Aplicar calibración a las propiedades"',
        device_only_label: 'Calibrar solo para dispositivo',
        payload_format: 'Marco de carga (dispositivo)',
        payload_format_change: 'Cambiar el marco de medición',
        payload_format_not_set: 'Aún no actualizado',
        payload_format_changed: 'Ultimo cambio',
        payload_format_updated: 'Última actualización',
        format: 'Marco de referencia',
        set_format: 'Establecer marco',

        dynamic_sensing: 'Detección dinámica',
        measurement_frame: 'Marco de medición',
        none: 'Ninguno',
        moisture: 'Humedad',
        temperature: 'Temperatura',
        light: 'Luz',
        measurement_sets: 'Conjuntos de medidas acumulados',
        measurement_interval: 'Intervalo de medición',
        downlik_period: 'Período de enlace descendente',
        downlink_retries: 'Reintentos de enlace descendente',
        transmitting_power: 'Transmisión de poder',
        message_interval: 'Intervalo de mensajes',
        device_lifespan: 'Vida útil del dispositivo',
        once_per_four: 'Una vez cada 4 días',
        once_per_two: 'Una vez cada 2 días',
        once_per_day: 'Una vez al día',
        twice_per_day: 'Dos veces al dia',
        set_dynamic_sensing: 'Establecer detección dinámica'
    },
    lqi: {
        Excellent: 'Excelente',
        Good: 'Buena',
        Average: 'Promedio',
        Limit: 'Limitada'
    },
    server_status: {
        title: 'Página de estado del servidor',
    },
    privacy: {
        title: 'Política de privacidad',
    },
    sigfox_coverage: {
        title: 'Herramienta de cobertura Sigfox',
        coverage_error: 'Error del servicio de cobertura de Sigfox',
        unstable: 'No hay cobertura y es posible que el dispositivo no se sincronice.',
        works_underground: 'El vínculo es fuerte y el dispositivo debe funcionar bajo tierra o en interiores profundos.',
        possible_underground: 'El vínculo es lo suficientemente fuerte para la posibilidad de trabajar bajo tierra o en interiores profundos.',
        works_indoor: 'El enlace es estable y el dispositivo debería funcionar en interiores (es posible que no funcione bajo tierra).',
        possible_indoor: 'El enlace es lo suficientemente estable para la posibilidad de trabajar en interiores. (puede que no funcione bajo tierra).',
        works_open: 'Es posible que el enlace no sea estable y el dispositivo debería funcionar en campo abierto.',
        possible_open: 'El dispositivo obtuvo un enlace y existe la posibilidad de que el dispositivo funcione en campo abierto.',
        coverage_env: "Colocación del dispositivo",
        coverage_env_greenhouse: "Invernadero",
        coverage_env_indoors: "Adentro",
        coverage_env_outdoors: "Al aire libre",
    },
    payload: {
        title: 'Carga útil del Soil 3XS',
    },
    export: {
        limit: 'Elige los últimos x valores de los tentáculos seleccionados',
        info: {
            first: 'Exportar',
            second: 'seleccionado',
            rest: 'Primero seleccione algunas unidades de la tabla',
        },
        tabs: {
            date_range: 'Rango de fechas',
            limit_values: 'Límite',
        },
    },
    contact_us: {
        title: 'Contáctenos',
        subj: 'Asunto',
        mess: 'Mensaje',
    },
    tooltips: {
        customer: 'Mostrando dispositivos asignados a este cliente.',
        logout: 'Cerrar sesión',
        total_units: 'Unidades totales',
        unit_name: 'Nombre de la unidad',
        excel: 'Exportar Excel',
        csv: 'Exportar CSV',
        search: 'o presione',
        tentacle_missing: 'elige al menos un tentacle',
    },
    buttons: {
        ok: 'Ok',
        login: 'Iniciar sesión',
        detail: 'Detalle',
        apply: 'Aplicar los cambios',
        apply_range: 'Aplicar rango',
        bulk: 'Configuración masiva',
        bulkdetail: 'Detalle del grupo',
        cancel: 'Cancelar',
        send: 'Enviar',
        export: 'Export',
        delete_range: 'Eliminar rango',
        next: 'Siguiente página',
        previous: 'Pagina anterior',
        save: 'Archivo',
    },
    metrics: {
        moisture: 'VWC',
        light: 'Luminosidad',
        temperature: 'Temperatura',
        battery: 'Batería',
        pressure: 'Presión',
        pump_mode: 'Bomba en funcionamiento',
        gyroscope: 'Vibraciones',
        events: 'Eventos',
        currents: 'Corriente de fase',
        angles: 'Ángulo de fase',
        over_vibration_stop: 'Parada de vibración excesiva',
    },
    timing: {
        t1: '15 minutos',
        t2: '30 minutos',
        t3: '1 hora',
        t4: '2 horas',
        t5: '8 horas',
        t6: 'Apagado',
    },
    interval: {
        day: 'día',
        week: 'por semana',
        month: 'por mes',
        year: 'por año',
    },
    notifications: {
        push: 'Alertas',
    },
    sensing: {
        sens1: 'Corriente Soil 3XT-4',
        sens2: 'Original 2x por hora',
        sens3: 'Humedad 4x por hora',
        sens4: 'Humedad 3x por 45 min',
        sens5: 'Humedad/Temp 2x por 30 min',
        sens6: 'Humedad/Temp/Ligero 2x por 30 min',
    },
    info: {
        loading_data: 'Cargando datos'
    },
    eventChart: {
        sequenceMessage: 'El número de secuencia esperado era {previous} vino {actual}',
        lqiMessage: 'Lqi es bajo para mensajes {badCount} pasados. El último fue "{lqi}"',
        invalidMessage: 'Dispositivo enviando datos incorrectos',
        ackMessage: 'La actualización esperada del dispositivo fue {expectedAt}',
        powerMessage: 'La potencia de salida del dispositivo cambió',
        settingsMessage: 'La configuración del dispositivo cambió',
        sequence: 'Número de secuencia faltante',
        lqi: 'LQI bajo',
        power: 'Cambio de potencia de transmisión',
        settings: 'Instellingen gewijzigd',
        invalid: 'Datos inválidos',
        pendingChange: 'Cambio pendiente',
        pendingChangeMessage: 'El dispositivo todavía no ha aplicado la configuración modificada.',
        ack: 'Configuración no aplicada',
        info: 'Información',
        warning: 'Advertencia',
        error: 'Error',
        latestEvent: 'Último Evento',
        sigfoxDeleted: 'Cloud OFF state',
        sigfoxCreated: 'Cloud ON state',
        deviceOn: 'Device ON',
        sigfoxDeletedMessage: 'Cloud device is set to OFF state',
        sigfoxCreatedMessage: 'Cloud device is set to ON state',
        deviceOnMessage: 'Device is ON remotely',
        events: 'Eventos'
    },
    header: {
        custom_name: "Nombre personalizado",
        generic_name: "Nombre genérico"
    }
};
